import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackTikTokPageView } from "../utils/tiktokPixel";

export const useTikTokPixelPageTracking = () => {
  const location = useLocation();

  useEffect(() => {
    trackTikTokPageView();
  }, [location.pathname, location.search]);
};
